import React from "react";
import { Col, Row } from "reactstrap";

//App
import Search from "../Search/Search";
import { Toggle } from "../../VFX-UI";
import { NewButton } from "../../Buttons";
import { SearchContainerProps } from "../../../../types";
import { CommonBaseDto } from "../../../../app/model/api/types/dto";
import useScreenSize from "../../../hooks/useScreenSize";
import { IsSmallScreen } from "../../../../utility/helpers";

const SearchContainer: React.FC<SearchContainerProps<CommonBaseDto>> = (
  props
) => {
  const {
    searchProps,
    activeToggle,
    newButtonStyle,
    handleActiveToggleChange,
    toggleNewViewHandler,
  } = props;
  const windowWidth = useScreenSize();
  const isSmallScreen = IsSmallScreen(windowWidth);
  const hasHeaderActions = handleActiveToggleChange || toggleNewViewHandler;

  return (
    <Row style={{ flex: 1 }}>
      <Col sm={12} md={hasHeaderActions ? 10 : 12}>
        {searchProps && <Search {...searchProps}></Search>}
      </Col>
      {hasHeaderActions && (
        <Col
          sm={12}
          md={2}
          className={`d-flex justify-content-${
            isSmallScreen ? "start" : "end"
          } mb-3`}
        >
          {handleActiveToggleChange && (
            <Toggle
              labelText="Active"
              handleChange={handleActiveToggleChange}
              defaultChecked={activeToggle ?? true}
            />
          )}
          {toggleNewViewHandler && (
            <NewButton
              style={newButtonStyle}
              toggleNewViewHandler={async () => await toggleNewViewHandler()}
            />
          )}
        </Col>
      )}
    </Row>
  );
};

export default SearchContainer;
